
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { UserModule } from '../../store/modules/user';
import {
  checkPermissionCompanyFromOrderType,
  checkPermissionCompany,
  checkPermissionRole,
  getModelPermission,

} from '@/utils/permission';
import { ModuleType, Type, ViewType } from '../../types/permissionType';

import { isFinish, bottomBtnTaskState } from '@/utils/orderStatsUtils';
import bbsDialog from '@/components/BbsDialog/index.vue';
import editDialog from '@/components/EditDialog/index.vue';
import { EditDialog } from '../../types/editDialogType';
import { orderPause, orderTaskAppear, taskFinish, taskSendReceive } from '@/api/orderTask';
import supplementProgressDialog from '@/components/SupplementProgressDialog/index.vue';
import eventBus from '../../utils/eventBus';

@Component({
  name: 'BtnGroup2',
  components: {
    bbsDialog,
    editDialog,
    supplementProgressDialog
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: true
  })
  orderTaskDetail!: any;

  private permissionType = Type;
  private isFinish = false;
  private orderTaskState = 0;
  private bbsState: any;

  private nowId: number = -1;
  private nowSid: number = -1;
  private nowTid: number = -1;
  private bbsDialogVisible: boolean = false;
  private priceVisible: boolean = false;

  // 解决list cell 重用问题  重点学习
  private btnList: Record<string, boolean> = {};
  @Watch('orderTaskDetail', {
    deep: true,
    immediate: true
  })
  handleChangeProps() {
    // 按钮需要在每次props改变后更新
    const orderState = bottomBtnTaskState(
      parseInt(this.orderTaskDetail.order_task.state)
    );
    // 巡检的判断
    let orderType = parseInt(this.orderTaskDetail.order.order_type);

    // this.state = orderState;
    // 按钮列表显示权限判断
    this.btnList = {
      'dealNow': orderState === 1 && orderType !== 4 && parseInt(this.orderTaskDetail.order_task.pause_last_state) !== 1,
      'finish': [2, 6].includes(orderState) && orderType !== 4,
      'extraInfo': orderState === 3,
      'receive': orderState === 4,
      'send': orderState === 5,
      'detail': orderState !== 8 && orderState !== 9,
      'bbs': ([7, 8, 9, 10].includes(orderState) || orderType === 4),
      'btnMore': [1, 2, 3, 4, 5, 6].includes(orderState) && orderType !== 4,
      'cooperate': [2, 3, 4, 5, 6].includes(orderState) && orderType !== 4
    };
  }

  private editDialogData: EditDialog = {
    visible: false,
    title: '',
    name: '',
    other: '',
    inputValue: '',
    inputHint: '',
    cancel: '',
    confirm: '',
    callBack: '',
    rules: []
  };

  private fixSummary:any={};

  created() {
    this.isFinish = isFinish(
      parseInt(this.orderTaskDetail.order_task.state)
    );
    this.orderTaskState = bottomBtnTaskState(
      parseInt(this.orderTaskDetail.order_task.state)
    );
    this.bbsState = parseInt(this.orderTaskDetail.order.state);
    this.fixSummary = getModelPermission(ViewType.DEAL_TASK, this.orderTaskDetail.order.order_type, 0, this.orderTaskDetail.order_task.company_id, ModuleType.ORDER_FIX_SUMMARY);
  }

  closeOrderCallBack() {

  }

  private pushHandle(enterType: any) {
    this.$router.push({
      path: '/Task/todealing',
      // 'taskDetail': data,
      query: {
        'taskId': this.orderTaskDetail.order_task.id,
        'companyId': this.orderTaskDetail.order_task.company_id,
        'orderType': this.orderTaskDetail.order.order_type,
        'enterType': enterType
      }
    });
  }
  // 立即处理
  private handleTaskNow() {
    this.pushHandle('1');
  }

  // 更多- 协同处理
  private cooperateHandle() {
    this.pushHandle('2');
  }

  // 更多-追加信息
  private addExtraInfoClick() {
    this.pushHandle('3');
  }
  // 任务选择寄修 等待客户发货时 追加信息
  private addExtraInfoForJiXiu() {
    this.pushHandle('3');
  }

  // 完成任务
  private finishTask() {
    this.pushHandle('4');
  }

  // 确认收货
  private confirmToReciveStaff() {
    this.$confirm('确认收货?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      showClose: false,
      type: 'warning'
    }).then(() => {
      this.handleSendRecive();
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private handleSendRecive() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.orderTaskDetail.order_task.company_id,
      order_task_id: this.orderTaskDetail.order_task.id
    };
    taskSendReceive(params).then(res => {
      this.showSuccessMsg('收货成功');
      setTimeout(() => {
        eventBus.$emit('orderTaskSearch');
      }, 500);
    }).catch((err) => {
      this.showErrorMsg(err.msg);
    });
  }
  /**
   * 点击寄回 完成寄修服务
   */
  private dialogSendBackVisible = false
  private formSendBack = {
    radio: '1',
    company: '',
    number: '',
    brief: ''
  }
  private sendBackStaff() {
    this.dialogSendBackVisible = true;
  }
  private sendBackConfirm() {
    if (!this.formSendBack.company) {
      this.showErrorMsg('请输入物流公司');
      return;
    }
    if (!this.formSendBack.number) {
      this.showErrorMsg('请输入物流单号');
      return;
    }
    if (!this.formSendBack.brief && this.fixSummary.m === 1) {
      this.showErrorMsg('请填写维修小结');
      return;
    }
    let that = this;
    this.$confirm('确认寄回 服务完成?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      showClose: false,
      type: 'warning'
    }).then(() => {
      that.sendBackToFinishTask();
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private sendBackToFinishTask() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.orderTaskDetail.order_task.company_id,
      order_task_id: this.orderTaskDetail.order_task.id,
      fix_summary: this.formSendBack.brief,
      reply_type: this.formSendBack.radio,
      reply_express_name: this.formSendBack.company,
      reply_express_number: this.formSendBack.number,
      is_quote_order: '0' // 生成报价单
    };
    taskFinish(params).then(res => {
      this.dialogSendBackVisible = false;
      this.showSuccessMsg('收货成功 任务完成');
      setTimeout(() => {
        eventBus.$emit('orderTaskSearch');
      }, 500);
    }).catch((err) => {
      this.showErrorMsg(err.msg);
    });
  }

  // 任务详情处理
  // private dialogTaskDetailVisible = false
  // private detail = {};
  // private task = {};
  // private isOrderTask = false;

  // private clickTaskDetail(detail: any, task: any) {
  //   this.dialogTaskDetailVisible = true;
  //   this.detail = detail;
  //   this.task = task;
  //   this.isOrderTask = true;
  // }

  // closeDetailHandle() {
  //   this.dialogTaskDetailVisible = false;
  // }

  // 补充进度
  private supplementProgressDialogVisible: boolean = false;
  supplementProgress() {
    this.supplementProgressDialogVisible = true;
  }

  SupplementProgressDialogClose() {
    this.supplementProgressDialogVisible = false;
  }

  // 上报
  aplayTask(r: any) {
    this.editDialogData = {
      visible: true,
      title: '上报',
      name: '备注',
      inputValue: '',
      other: '',
      inputHint: '请填写备注',
      cancel: '取消',
      confirm: '确定',
      callBack: 'aplayTaskCallBack',
      rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
    };
  }

  aplayTaskCallBack(editDialogData : EditDialog) {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      order_task_id: this.orderTaskDetail.order_task.id,
      remark: editDialogData.inputValue
    };
    orderTaskAppear(params).then((res:any) => {
      this.showSuccessMsg('上报成功');
      this.editDialogData.visible = false;
      setTimeout(() => {
        eventBus.$emit('orderTaskSearch');
      }, 500);
    }).catch((err:any) => {
      let msg = err.msg;
    });
  }

  videoCall(r: any) {
    let routeData = this.$router.resolve({
      path: '/VideoCall',
      query: {
        order_id: this.orderTaskDetail.order.id,
        order_service_id: this.orderTaskDetail.order_service.id,
        order_task_id: this.orderTaskDetail.order_task.id,
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
        user_id: UserModule.getUserId
      }
    });
    window.open(routeData.href, '_blank');
  }

  // 留言
  bbsHandle(r: any) {
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.nowTid = parseInt(r.order_task.id);
    this.bbsDialogVisible = true;
  }

  closeBbs(value: boolean) {
    setTimeout(() => {
      eventBus.$emit('orderTaskSearch');
    }, 500);
    this.bbsDialogVisible = value;
  }

  private checkPermissionCompanyFromOrderType(companyId: string, permission: Type, orderType: any) {
    return checkPermissionCompanyFromOrderType(companyId, permission, orderType);
  }

  private checkPermissionCompany(companyId: string, permission: Type) {
    return checkPermissionCompany(companyId, permission);
  }

  private checkPermissionRole(companyId: string, permission: Type) {
    return checkPermissionRole(companyId, permission);
  }

  pauseTaskHandle(val: any) {
    if (parseInt(val.order_task.pause_last_state) === 1) {
      this.pauseTask(false);
    } else {
      this.editDialogData = {
        visible: true,
        title: '暂停任务',
        name: '备注',
        inputValue: '',
        inputHint: '请填写备注信息',
        other: '暂停任务之后，再次处理，需继续开始该任务，否则任务无法服务完成。',
        cancel: '取消',
        confirm: '确定',
        callBack: 'pauseTaskCallBack',
        rules: [{ required: true, message: '请填写备注信息', trigger: 'blur' }]
      };
    }
  }
  private pauseTaskCallBack(editDialogData : EditDialog) {
    this.pauseTask(true);
  }

  private pauseTask(isPause:boolean) {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.orderTaskDetail.order_task.company_id;
    params.order_task_id = this.orderTaskDetail.order_task.id;
    if (this.editDialogData.inputValue) {
      params.remark = this.editDialogData.inputValue;
    }

    params.pause_state = isPause ? '1' : '2';
    orderPause(params).then((res:any) => {
      setTimeout(() => {
        eventBus.$emit('orderTaskSearch');
      }, 500);
      this.showSuccessMsg(res.msg);
      this.editDialogData.visible = false;
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private customHeight = window.innerHeight * 0.4;
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: this.customHeight,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
